export enum Status {
	WaitingForPlayers = 'waitingForPlayers',
	PreQuestion = 'preQuestion',
	Question = 'question',
	PostQuestion = 'postQuestion',
	Leaderboard = 'leaderboard',
}
